import { Alert, AlertIcon, Box } from "@chakra-ui/react";
import { Appointment } from "../../modals/Appointment";
import moment from "moment";
import { Flex, HStack, Icon, Text, Link } from "@chakra-ui/react";
import { BsCalendarFill, BsFillCalendarCheckFill } from "react-icons/bs";
import { MdLocationOn } from "react-icons/md";
import { JobEstimationDetail } from "../../modals/JobEstimationDetail";
import CompanyMap from "../CompanyMap";
import { createEvent } from "../CreateEvent";

require("./DisplayBooking.css");

interface DisplayBookingProps {
  estimateDetails: JobEstimationDetail;
  appointment?: Appointment;
}

const DisplayBooking = (props: DisplayBookingProps) => {
  const mapIframe = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3156.6110651134736!2d152.9913919!3d-27.41808!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b915774ed913c9b%3A0x787592295017734!2sFlow+Autobody!5e0!3m2!1sen!2sau!4v1666168111046!5m2!1sen!2sau`;

  const expectedArrivalDateOnly = moment(
    props.estimateDetails.expectedArrival,
    "YYYY-MM-DD"
  ).toDate();

  return (
    <Flex mb={4} p={4} boxShadow={"base"} borderRadius={4} flexFlow={"column"}>
      <Text
        fontSize="xl"
        fontWeight={"bold"}
        color={"blue.700"}
        textTransform={"uppercase"}
        mb={4}
      >
        {props.estimateDetails.expectedEnd
          ? "Booking Request"
          : "Booking Request Confirmation"}
      </Text>
      <HStack mb={4}>
        <Icon as={BsCalendarFill} w={10} h={10} mr={2} color={"blue.500"} />
        <Flex gap={"20px"} textAlign={"left"}>
          <div>
            <Text fontSize={"small"} fontWeight={"bold"}>
              Drop Off Date
            </Text>
            <Text fontSize={"medium"}>
              {moment(props.estimateDetails.expectedArrival)?.format(
                "dddd, DD/MM/YYYY"
              )}
            </Text>
            <Text
              fontSize={"small"}
              textDecoration={"underline"}
              cursor={"pointer"}
              marginLeft={"2px"}
              marginTop={"3px"}
              onClick={() => {
                createEvent(expectedArrivalDateOnly, "Booking");
              }}
            >
              Add To Calendar
            </Text>
          </div>
          <div>
            <Text fontSize={"small"} fontWeight={"bold"}>
              Time
            </Text>
            <Text fontSize={"medium"}>
              {moment(props.estimateDetails.expectedArrival).format("hh:mm a")}
            </Text>
          </div>
        </Flex>
      </HStack>
      {props.estimateDetails.expectedPickup && (
        <HStack mb={4}>
          <Icon
            as={BsFillCalendarCheckFill}
            w={10}
            h={10}
            mr={2}
            color={"blue.500"}
          />
          <Flex flexFlow={"column"} textAlign={"left"}>
            <Text fontSize={"small"} fontWeight={"bold"}>
              Pick up Date
            </Text>
            <Text fontSize={"medium"}>
              {moment(props.estimateDetails.expectedPickup)?.format(
                "dddd, DD/MM/YYYY"
              )}
            </Text>
          </Flex>
        </HStack>
      )}
      <HStack mb={4}>
        <Icon as={MdLocationOn} w={10} h={10} mr={2} color={"blue.500"} />
        <Flex flexFlow={"column"} textAlign={"left"}>
          <Text fontSize={"small"} fontWeight={"bold"}>
            Location
          </Text>
          <Link
            href={
              "https://www.google.com/maps/place/Flow+Autobody/@-27.41808,152.9913919,17z/data=!4m13!1m7!3m6!1s0x6b9157748dcf3b43:0x975c92977c38c430!2s256+S+Pine+Rd,+Enoggera+QLD+4051!3b1!8m2!3d-27.41808!4d152.9935806!3m4!1s0x6b915774ed913c9b:0x787592295017734!8m2!3d-27.41808!4d152.9935806"
            }
            isExternal
          >
            <Text fontSize={"medium"}>256 S Pine Rd, Enoggera QLD 4051</Text>
          </Link>
        </Flex>
      </HStack>
      <Box justifyContent="center" alignItems="center" mb={4}>
        <CompanyMap mapIframe={mapIframe} />
      </Box>
      {!props.estimateDetails.expectedEnd && (
        <Alert
          borderRadius={4}
          status="success"
          variant="subtle"
          alignItems={"start"}
          textAlign={"left"}
        >
          <AlertIcon />
          Your booking has been confirmed
        </Alert>
      )}
    </Flex>
  );
};

export default DisplayBooking;
